import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { getAllCollection, addToCollection } from '../services/database';
import { Container } from '../components/tables/Style';
import { AddButton } from '../components/tables/Buttons';

// Stilovi
const StyledInput = styled.input`
    width: 100%;
    height: 40px;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
`;

const StyledCheckbox = styled.input`
    margin: 10px;
`;

const StyledH1 = styled.h1`
    color: #fff;
    font-size: 18px;
    margin: 15px 0 5px;
`;

const AddSlider = () => {
    const history = useHistory();
    const [inputs, setInputs] = useState({
        image_url: '',
        title: '',
        link: '',
        subtitle: '',
        order_number: '',
        active: false,
    });

    const [error, setError] = useState('');

    const handleSaveButton = async () => {
        const orderNumInt = parseInt(inputs.order_number);
        if (isNaN(orderNumInt)) {
            setError('Order number mora biti broj.');
            return;
        }

        const { data: existingItems } = await getAllCollection('slider_items');
        const alreadyExists = existingItems?.some(item => item.order_number === orderNumInt);

        if (alreadyExists) {
            setError(`Slider sa order_number ${orderNumInt} već postoji.`);
            return;
        }

        const newSlider = {
            ...inputs,
            order_number: orderNumInt
        };

        try {
            await addToCollection('slider_items', orderNumInt.toString(), newSlider);
            history.push('/slider');
        } catch (error) {
            console.error('Greška pri dodavanju slidera:', error);
            setError('Došlo je do greške prilikom spremanja.');
        }
    };

    return (
        <Container>
            <StyledH1>Redni broj:</StyledH1>
            <StyledInput
                type="number"
                value={inputs.order_number}
                onChange={(e) => setInputs({ ...inputs, order_number: e.target.value })}
            />

            <StyledH1>Naslov:</StyledH1>
            <StyledInput
                type="text"
                value={inputs.title}
                onChange={(e) => setInputs({ ...inputs, title: e.target.value })}
            />

            <StyledH1>Podnaslov:</StyledH1>
            <StyledInput
                type="text"
                value={inputs.subtitle}
                onChange={(e) => setInputs({ ...inputs, subtitle: e.target.value })}
            />

            <StyledH1>Link:</StyledH1>
            <StyledInput
                type="text"
                value={inputs.link}
                onChange={(e) => setInputs({ ...inputs, link: e.target.value })}
            />

            <StyledH1>Slika (URL):</StyledH1>
            <StyledInput
                type="text"
                value={inputs.image_url}
                onChange={(e) => setInputs({ ...inputs, image_url: e.target.value })}
            />

            <StyledH1>Aktivan:</StyledH1>
            <label>
                <StyledCheckbox
                    type="checkbox"
                    checked={inputs.active}
                    onChange={(e) => setInputs({ ...inputs, active: e.target.checked })}
                />
                Aktiviraj
            </label>

            {error && <p style={{ color: 'red' }}>{error}</p>}

            <AddButton onClick={handleSaveButton}>➕ Sačuvaj novi slider</AddButton>
        </Container>
    );
};

export default AddSlider;
